module.exports = __webpack_public_path__ + "img/salad-1600x800.75ea7e85.jpg";